import { Pipe, PipeTransform } from "@angular/core";

export class StringUtil {

  static formatarNumeroMilharesCentenas(number: number): string {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  static formatarNumeroTextoNatural(number: number): string {
    if (number < 1000) {
      return number.toString();
    } else if (number < 1_000_000) {
      return `${(number / 1000).toFixed(number % 1000 === 0 ? 0 : 1).replace(".", ",")} mil`;
    } else if (number < 1_000_000_000) {
      return `${(number / 1_000_000).toFixed(number % 1_000_000 === 0 ? 0 : 2).replace(".", ",")} milhões`;
    } else {
      return `${(number / 1_000_000_000).toFixed(number % 1_000_000_000 === 0 ? 0 : 2).replace(".", ",")} bilhões`;
    }
  }

  static obterSexoPorExtenso(sexo?: string): string {
    if (sexo === 'M') {
      return 'Masculino';
    } else if (sexo === 'F') {
      return 'Feminino';
    } else {
      return 'Não informado';
    }
  }

  static formatarCPF(cpf?: string): string {
    if (!cpf) return 'Não informado';

    cpf = cpf.replace(/\D/g, '');

    if (cpf.length !== 11) return cpf;

    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  static formatarRG(rg?: string): string {
    if (!rg) return 'Não informado';

    rg = rg.replace(/\D/g, '');

    if (rg.length === 9) {
      return rg.replace(/(\d{2})(\d{3})(\d{3})(\d{1})/, '$1.$2.$3-$4');
    }

    if (rg.length === 8) {
      return rg.replace(/(\d{2})(\d{3})(\d{3})/, '$1.$2.$3');
    }

    return rg;
  }
  static formatarCelular(telefone?: string): string {
    if (!telefone) return '-';

    telefone = telefone.replace(/\D/g, '');

    switch (telefone.length) {
      case 11:
        return telefone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        break;
      case 10:
        return telefone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
        break;
      case 9:
        return telefone.replace(/(\d{5})(\d{4})/, '$1-$2');
        break;
      case 8:
        return telefone.replace(/(\d{4})(\d{4})/, '$1-$2');
        break;
      default:
        return telefone;
        break;
    }
  }
}